import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import NotificationAPI from '../../../../axios/notification';
import { PanelIcon } from '../../user-panel';
import { PanelPagination } from '../panel-ui';
import UserNotification from '../user-notification/user-notification';

export const UserNotificationList = () => {
    const { t, i18n } = useTranslation(["message"]);
    const lang = i18n.language;
    const [notifications, setNotifications] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [pageNum, setPageNum] = useState(1);

    useEffect(() => {
        let cancelled = false;
        NotificationAPI.getNotifications(pageNum, lang).then(response => {
            if (cancelled) return;
            setNotifications(response.data.results);
            setPageCount(response.data.page_count);
            setLoaded(true);
        }).catch(error => console.error('Error fetching notifications:', error));
        return () => { cancelled = true; };
    }, [pageNum, lang]);

    if (!loaded) return null;

    if (notifications.length === 0) {
        return (
            <section className='hs hs-panel-card hs-panel-empty'>
                <span className='hs-panel-empty-icon'><PanelIcon name='bell' size={24} /></span>
                <h2>{t("no_notifications")}</h2>
                <p>{t("no_notifications_text")}</p>
            </section>
        );
    }

    return (
        <section className='hs hs-panel-page'>
            <div className='hs-panel-card hs-panel-messages'>
                {notifications.map(notification => (
                    <UserNotification notification={notification} key={`user-notification-${notification.id}`} />
                ))}
            </div>
            <PanelPagination page={pageNum} pageCount={pageCount} onChange={setPageNum} />
        </section>
    );
};
